// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"427":"1e6655ad","868":"f84c1a78","968":"48977a39"}[chunkId] + ".css";
};